export default __webpack_public_path__ + "static/media/comete-coco.efa6e9de.jpg";